import React from 'react'
import { Grid, GridItem } from '../../components/grid'
import Spacer from '../../components/spacer'
import ImageScale from '../../components/scale/image_scale'
import css from './style.css'

const ColourSection = props => {
  /** ------------- */
  /** COLOUR SCALE  */
  /** ------------- */

  const d = require('./images/colourScale/D@2x.png')
  const e = require('./images/colourScale/E@2x.png')
  const f = require('./images/colourScale/F@2x.png')
  const g = require('./images/colourScale/G@2x.png')
  const h = require('./images/colourScale/H@2x.png')
  const i = require('./images/colourScale/I@2x.png')
  const j = require('./images/colourScale/J@2x.png')
  const k = require('./images/colourScale/K@2x.png')
  const l = require('./images/colourScale/L@2x.png')
  const m = require('./images/colourScale/M@2x.png')
  const n = require('./images/colourScale/N@2x.png')
  const o = require('./images/colourScale/O@2x.png')
  const p = require('./images/colourScale/P@2x.png')
  const q = require('./images/colourScale/Q@2x.png')
  const r = require('./images/colourScale/R@2x.png')
  const s = require('./images/colourScale/S@2x.png')
  const t = require('./images/colourScale/T@2x.png')
  const u = require('./images/colourScale/U@2x.png')
  const v = require('./images/colourScale/V@2x.png')
  const w = require('./images/colourScale/W@2x.png')
  const x = require('./images/colourScale/X@2x.png')
  const y = require('./images/colourScale/Y@2x.png')
  const z = require('./images/colourScale/Z@2x.png')

  const colourScale = [
    {
      elements: [
        { img: d, name: 'D' },
        { img: e, name: 'E' },
        { img: f, name: 'F' }
      ],
      description: 'Colourless'
    },
    {
      elements: [
        { img: g, name: 'G' },
        { img: h, name: 'H' },
        { img: i, name: 'I' },
        { img: j, name: 'J' }
      ],
      description: 'Near Colourless'
    },
    {
      elements: [
        { img: k, name: 'K' },
        { img: l, name: 'L' },
        { img: m, name: 'M' }
      ],
      description: 'Faint'
    },
    {
      elements: [
        { img: n, name: 'N' },
        { img: o, name: 'O' },
        { img: p, name: 'P' },
        { img: q, name: 'Q' },
        { img: r, name: 'R' }
      ],
      description: 'Very Light'
    },
    {
      elements: [
        { img: s, name: 'S' },
        { img: t, name: 'T' },
        { img: u, name: 'U' },
        { img: v, name: 'V' },
        { img: w, name: 'W' },
        { img: x, name: 'X' },
        { img: y, name: 'Y' },
        { img: z, name: 'Z' }
      ],
      description: 'Light'
    }
  ]
  return (
    <div>
      <Grid>
        <div className={css.backgroundColour} />
        <GridItem col='4/10' customStyle={css.gridItem}>
          <Spacer lg />
          <div className={css.title}>
            Colour
          </div>
          <p className={css.text}>
            White diamonds are graded on a scale from the whitest colour D, down to the extremely yellow-tinted Z. Diamonds graded D to F are known as “colourless” and are extremely rare; G is considered a “rare white”; and H is considered “baseline white”. Side-by-side, it is very difficult to tell the difference between adjacent colour grades, and the difference between diamonds that are two colour grades apart will hardly be noticeable once the diamond is set. Diamonds graded D and E can be significantly more expensive without offering much benefit; on the other hand, H graded diamonds are very bright and white. To maximize value, while maintaining a colourless look, our preferred range is F to I.
          </p>
        </GridItem>
        <GridItem col='6/10' customStyle={[css.gridItem, 'right'].join(' ')}>
          <img className={css.image}
            src={require('./images/colour_diamond_ring.png')}
            srcSet={[
              require('./images/colour_diamond_ring.png') + ' 1x',
              require('./images/colour_diamond_ring@2x.png') + ' 2x'
            ].join(', ')}
          />
        </GridItem>
      </Grid>
      <Spacer xl />
      <Grid>
        <GridItem col='1/1' customStyle={css.gridItem}>
          <ImageScale elements={colourScale} imgHeight={30} />
        </GridItem>
      </Grid>
    </div>
  )
}

export default ColourSection



// WEBPACK FOOTER //
// ./src/containers/diamond/colour_section.js